import React, { Component } from 'react';

class Spinner extends Component {
    render() {
        return (
            <div class="spinner--animation white">
                <div className="spinner--block rotateG_01"></div>
                <div className="spinner--block rotateG_02"></div>
                <div className="spinner--block rotateG_03"></div>
                <div className="spinner--block rotateG_04"></div>
                <div className="spinner--block rotateG_05"></div>
                <div className="spinner--block rotateG_06"></div>
                <div className="spinner--block rotateG_07"></div>
                <div className="spinner--block rotateG_08"></div>
            </div>
        );
    }
}

export default Spinner;
